
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingReceiptGrid extends Serenity.EntityGrid<TreeMakingReceiptRow, any> {
        protected getColumnsKey() { return 'Production.TreeMakingReceipt'; }
        protected getDialogType() { return TreeMakingReceiptDialog; }
        protected getIdProperty() { return TreeMakingReceiptRow.idProperty; } 
        protected getLocalTextPrefix() { return TreeMakingReceiptRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
        }
    }
}